// extracted by mini-css-extract-plugin
export var center = "_1g-2";
export var clickableRow = "_1g-5";
export var expandedRow = "_1g-7";
export var hoverable = "_1g-4";
export var left = "_1g-1";
export var right = "_1g-3";
export var row = "_1g-0";
export var selectedRow = "_1g-6";
export var summaryRow = "_1g-8";